module.exports = __webpack_public_path__ + "static/media/Med_stod_fran_Allmanna_Arvsfonden_SV_pos.b00d9b38.png";